// Extracted from sections/ov-cart-drawer.liquid (perf lot 1). Classic script loaded with defer.
(function () {
  if (window.__ovCartInit) return;
  window.__ovCartInit = true;

  var HANDLE = (document.currentScript && document.currentScript.dataset.sectionId) || 'ov-cart-drawer';
  var isOpen = false;

  function drawer()  { return document.getElementById('ov-cart-drawer'); }
  function overlay() { return document.getElementById('ov-cart-overlay'); }

  function openCart() {
    var d = drawer(), o = overlay();
    if (!d) return;
    isOpen = true;
    d.style.transform = 'translateX(0)';
    d.removeAttribute('aria-hidden');
    o.style.opacity = '1';
    o.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
    loadRecos();
  }

  // Upsell selon le panier : recommandations Shopify pour le dernier produit ajouté,
  // rendues par la section elle-même (branche recommendations.performed?). Sans
  // résultat, les cartes de la collection upsell restent affichées.
  var recoCache = {};
  function loadRecos() {
    var box = document.querySelector('[data-cart-upsell]');
    if (!box) return;
    var intent = box.getAttribute('data-reco-intent');
    var pid = box.getAttribute('data-reco-product');
    if (!pid || !intent || intent === 'off') return;
    var key = pid + ':' + intent;
    var apply = function (html) {
      var current = document.querySelector('[data-cart-upsell]');
      if (!current || !html) return;
      current.querySelector('#ov-cart-upsell-scroll').innerHTML = html;
      current.hidden = false;
    };
    if (key in recoCache) { apply(recoCache[key]); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products?section_id=' + encodeURIComponent(HANDLE) + '&product_id=' + encodeURIComponent(pid) + '&limit=10&intent=' + encodeURIComponent(intent))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var items = tmp.querySelector('[data-reco-items]');
        var html = items && items.querySelector('[data-cart-upsell-card]') ? items.innerHTML : '';
        recoCache[key] = html;
        apply(html);
      })
      .catch(function () { recoCache[key] = ''; });
  }

  function closeCart() {
    var d = drawer(), o = overlay();
    if (!d) return;
    isOpen = false;
    d.style.transform = 'translateX(100%)';
    d.setAttribute('aria-hidden', 'true');
    o.style.opacity = '0';
    o.style.pointerEvents = 'none';
    document.body.style.overflow = '';
  }

  function refreshCart() {
    return fetch(window.location.pathname + '?sections=' + HANDLE)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[HANDLE];
        if (!html) return;
        var wrapper = document.getElementById('shopify-section-' + HANDLE);
        if (wrapper) wrapper.outerHTML = html;
        if (isOpen) openCart();
        // Sync navbar cart badge from freshly rendered drawer count
        var countEl = document.querySelector('#ov-cart-drawer h2 .ov-rounded-full');
        var count = countEl ? parseInt(countEl.textContent.trim(), 10) : 0;
        document.querySelectorAll('[data-cart-trigger]').forEach(function(trigger) {
          var badge = trigger.querySelector('.ov-bg-orange');
          if (count > 0) {
            if (badge) {
              badge.textContent = count;
            } else {
              var span = document.createElement('span');
              span.className = 'ov-absolute -ov-top-1 -ov-right-1 ov-w-[17px] ov-h-[17px] ov-bg-orange ov-rounded-full ov-border-2 ov-border-cream ov-font-heading ov-text-[9px] ov-font-bold ov-text-white ov-flex ov-items-center ov-justify-center';
              span.setAttribute('aria-hidden', 'true');
              span.textContent = count;
              trigger.appendChild(span);
            }
          } else {
            if (badge) badge.remove();
          }
        });
        return applyGiftFixes();
      });
  }

  // Subscription gifts guard: snippets/ov-gift-guard.liquid renders the gift lines
  // that break the rules (no subscribed pack, not added by the pack, customer already
  // gifted, duplicate, qty > 1). Fix them, then re-render. Capped so a failing
  // /cart/change.js cannot loop.
  var giftFixRuns = 0;
  function applyGiftFixes() {
    var el = document.querySelector('[data-ov-gift-fix]');
    var fixes;
    try { fixes = JSON.parse(el ? el.textContent : '[]'); } catch (err) { fixes = []; }
    if (!fixes.length) {
      giftFixRuns = 0;
      try { sessionStorage.removeItem('ovGiftReloads'); } catch (err) {}
      return Promise.resolve();
    }
    if (giftFixRuns++ >= 2) return Promise.resolve();
    var chain = Promise.resolve();
    fixes.forEach(function (f) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: f.key, quantity: f.quantity })
        });
      });
    });
    return chain.then(function () {
      // The cart page is server-rendered: reload it to show the fixed cart.
      if (/\/cart\/?$/.test(window.location.pathname)) {
        var reloads = 0;
        try { reloads = parseInt(sessionStorage.getItem('ovGiftReloads') || '0', 10); sessionStorage.setItem('ovGiftReloads', String(reloads + 1)); } catch (err) { reloads = 2; }
        if (reloads < 2) window.location.reload();
        return;
      }
      return refreshCart();
    }).catch(function (err) { console.error('Gift guard failed:', err); });
  }

  document.addEventListener('click', function (e) {
    // Close button
    if (e.target.closest('#ov-cart-close')) { closeCart(); return; }

    // Overlay click
    if (e.target === overlay()) { closeCart(); return; }

    // Cart trigger
    // Cart trigger. The cart may have changed outside the drawer (another tab, a direct
    // /cart/add.js): re-render when it did, so the gift guard sees the current cart.
    if (e.target.closest('[data-cart-trigger]')) {
      e.preventDefault();
      openCart();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var d = drawer();
        if (d && d.dataset.cartSig !== c.item_count + '-' + c.total_price) return refreshCart();
      }).catch(function () {});
      return;
    }

    // Pack subscription toggle: swap every pack line to/from its own matching plan.
    // Gift lines are removed when unsubscribing; gift products are added when subscribing.
    var packSubBtn = e.target.closest('[data-pack-sub-toggle]');
    if (packSubBtn) {
      var goOff = packSubBtn.dataset.subOn === '1';
      var wantCadence = (packSubBtn.dataset.subDefault || '').toLowerCase();
      var giftKeys = (packSubBtn.dataset.packSubGiftKeys || '').split(',').filter(Boolean);
      var giftAdds = (packSubBtn.dataset.packSubAdd || '').split(',').filter(Boolean);
      var giftPackId = packSubBtn.dataset.packSubId || '';
      packSubApply(packSubBtn, function (plans, key) {
        if (giftKeys.indexOf(key) !== -1) return goOff ? { removeLine: true } : undefined;
        if (goOff) return null;
        var m = plans.find(function (p) { return p.name.toLowerCase().indexOf(wantCadence) !== -1; }) || plans[0];
        return m ? m.id : undefined;
      }, function () {
        if (goOff || !giftAdds.length || giftKeys.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: giftAdds.map(function (v) {
            return { id: parseInt(v, 10), quantity: 1, properties: { '_pack': 'Composez votre pack', '_pack_id': giftPackId, '_pack_gift': '1', '_pack_unit_qty': '1' } };
          }) })
        });
      });
      return;
    }

    // Subscription toggle on a cart line: swap the line to/from its selling plan
    var subBtn = e.target.closest('[data-sub-toggle]');
    if (subBtn) {
      var subBody = { id: subBtn.dataset.subKey, quantity: parseInt(subBtn.dataset.subQty, 10) };
      subBody.selling_plan = subBtn.dataset.subOn === '1' ? null : parseInt(subBtn.dataset.subPlan, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subBody)
      }).then(refreshCart).catch(function(err) { console.error('Sub toggle failed:', err); });
      return;
    }

    // Pack qty change / remove: scale every line of the pack by its per-pack unit qty
    var packBtn = e.target.closest('[data-pack-keys][data-pack-target]');
    if (packBtn) {
      var packKeys = packBtn.dataset.packKeys.split(',').filter(Boolean);
      var packUnits = packBtn.dataset.packUnits.split(',').filter(Boolean).map(Number);
      var packTarget = parseInt(packBtn.dataset.packTarget, 10);
      var chain = Promise.resolve();
      packKeys.forEach(function (k, i) {
        var q = packTarget <= 0 ? 0 : (packUnits[i] || 1) * packTarget;
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: k, quantity: q })
          });
        });
      });
      chain.then(refreshCart).catch(function(err) { console.error('Pack change failed:', err); });
      return;
    }

    // Qty change / remove
    var qtyBtn = e.target.closest('[data-cart-key][data-cart-qty]');
    if (qtyBtn) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qtyBtn.dataset.cartKey, quantity: parseInt(qtyBtn.dataset.cartQty, 10) })
      }).then(refreshCart).catch(function(err) { console.error('Cart change failed:', err); });
      return;
    }

    // Add product (upsell or PLP)
    var addBtn = e.target.closest('[data-cart-add]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      var origText = addBtn.textContent;
      addBtn.textContent = '...';
      var cartBody = { id: parseInt(addBtn.dataset.cartAdd, 10), quantity: 1 };
      var parentForm = addBtn.closest('form');
      if (parentForm) {
        var spField = parentForm.querySelector('[name="selling_plan"]:not([disabled])');
        if (spField && spField.value) cartBody.selling_plan = parseInt(spField.value, 10);
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartBody)
      }).then(function () {
        return refreshCart().then(openCart);
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = origText;
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeCart();
  });

  // Apply a per-line resolution to every line of a pack, sequentially.
  // resolveLine returns: a plan id, null (drop the plan), {removeLine:true}, or undefined (skip).
  function packSubApply(el, resolveLine, after) {
    var keys = el.dataset.packSubKeys.split(',').filter(Boolean);
    var qtys = el.dataset.packSubQtys.split(',').filter(Boolean).map(Number);
    var plans;
    try { plans = JSON.parse(el.dataset.packSubPlans || '{}'); } catch (err) { plans = {}; }
    var chain = Promise.resolve();
    keys.forEach(function (k, i) {
      var action = resolveLine(plans[k] || [], k);
      if (action === undefined) return;
      var body = { id: k, quantity: qtys[i] };
      if (action && action.removeLine) body.quantity = 0;
      else body.selling_plan = action;
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      });
    });
    chain.then(function () { return after ? after() : null; })
      .then(refreshCart)
      .catch(function(err) { console.error('Pack sub change failed:', err); });
  }

  // Cadence dropdowns: single subscribed line, and whole pack (matched by plan name)
  document.addEventListener('change', function (e) {
    var packSel = e.target.closest('[data-pack-sub-select]');
    if (packSel) {
      var wantName = packSel.value;
      packSubApply(packSel, function (plans) {
        var m = plans.find(function (p) { return p.name === wantName; });
        return m ? m.id : undefined;
      });
      return;
    }
    var sel = e.target.closest('[data-sub-select]');
    if (!sel) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: sel.dataset.subKey, quantity: parseInt(sel.dataset.subQty, 10), selling_plan: parseInt(sel.value, 10) })
    }).then(refreshCart).catch(function(err) { console.error('Cadence change failed:', err); });
  });

  document.addEventListener('ov:cart:open', function() { refreshCart().then(openCart); });

  applyGiftFixes();

  // Theme editor: selecting the section (or changing a setting) re-renders its HTML,
  // which resets the drawer to its default off-screen state. Reopen it so the
  // merchant can see and interact with the drawer while editing.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === HANDLE) openCart();
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId === HANDLE) openCart();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === HANDLE) closeCart();
    });
  }
})();
